"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ResolveAddLinks = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var ResolveAddLinks = /*#__PURE__*/function () {
  function ResolveAddLinks(modalRef, configcad) {
    (0, _classCallCheck2["default"])(this, ResolveAddLinks);
    this.modal = modalRef;
    if (configcad && configcad.showAddLinksPop) this.showAddLinksPop = true;else this.showAddLinksPop = false;
  }
  (0, _createClass2["default"])(ResolveAddLinks, [{
    key: "resolve",
    value: function () {
      var _resolve = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(addLinksData) {
        var _this = this;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (_this.showAddLinksPop) {
                  switch (addLinksData.getInsertType()) {
                    case AddLinksResolveEnum.INSERT_DIRECT:
                    case AddLinksResolveEnum.NO_FREE_POSITION:
                      resolve(null);
                      break;
                    case AddLinksResolveEnum.INSERT_BY_ADDLINK:
                      return _this.modal.open(addLinksData).then(function (res) {
                        return resolve(res);
                      })["catch"](function (err) {
                        return reject(err);
                      });
                      break;
                  }
                } else {
                  resolve(null);
                }
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function resolve(_x) {
        return _resolve.apply(this, arguments);
      }
      return resolve;
    }()
  }]);
  return ResolveAddLinks;
}();
exports.ResolveAddLinks = ResolveAddLinks;
var AddLinksResolveEnum;
(function (AddLinksResolveEnum) {
  AddLinksResolveEnum[AddLinksResolveEnum["INSERT_DIRECT"] = 0] = "INSERT_DIRECT";
  AddLinksResolveEnum[AddLinksResolveEnum["NO_FREE_POSITION"] = 1] = "NO_FREE_POSITION";
  AddLinksResolveEnum[AddLinksResolveEnum["INSERT_BY_ADDLINK"] = 2] = "INSERT_BY_ADDLINK";
})(AddLinksResolveEnum || (AddLinksResolveEnum = {}));
//# sourceMappingURL=ResolveAddLinks.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/ResolveAddLinks.js
// module id = 1247
// module chunks = 142